import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * @typedef {{ label: string, details?: string, error: string }} CheckoutLeftoverRow
 */

function CheckoutLeftoversDialog({ open, rows, onClose }) {
  const { t } = useTranslation();
  const list = rows || [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('cart.checkoutLeftoversTitle')}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t('cart.checkoutLeftoversBody')}
        </Typography>
        <List dense disablePadding>
          {list.map((row, i) => (
            <ListItem key={i} alignItems="flex-start" sx={{ px: 0 }}>
              <ListItemText
                primary={row.label}
                secondary={(
                  <>
                    {row.details ? (
                      <Typography component="span" variant="body2" color="text.secondary" display="block">
                        {row.details}
                      </Typography>
                    ) : null}
                    <Typography component="span" variant="body2" color="error.main" display="block">
                      {row.error}
                    </Typography>
                  </>
                )}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, flexWrap: 'wrap', gap: 1 }}>
        <Button component={RouterLink} to="/cart" onClick={onClose}>
          {t('cart.checkoutLeftoversGoToCart')}
        </Button>
        <Button variant="contained" onClick={onClose}>
          {t('common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CheckoutLeftoversDialog;
